import React from 'react'
import Box from '@material-ui/core/Box'
import GroupEventInfo from './group-event-info'
import ContactInformation from './contact-information'
import ParticipantInformation from './participant-information'
import PriceDetails from './price-details'
import SignInNudge from './sign-in-nudge'
import PaymentInformation from './payment-information'
import RegisterButton from './register-button'

const MobileLayout = ({ groupEvent, paymentRequired, setPaymentRequired }) => {
  return (
    <>
      <Box
        px={2}
        py={3}
        style={{ backgroundColor: 'white', marginTop: '1px' }}
        mb={0.5}
      >
        <GroupEventInfo groupEvent={groupEvent} />
      </Box>
      <Box px={2} pt={3} pb={1} mb={0.5} style={{ backgroundColor: 'white' }}>
        <SignInNudge />
        <ParticipantInformation />
      </Box>
      <Box px={2} py={3} mb={0.5} style={{ backgroundColor: 'white' }}>
        <ContactInformation />
      </Box>
      <Box px={2} py={3} mb={0.5} style={{ backgroundColor: 'white' }}>
        <PriceDetails
          groupEvent={groupEvent}
          paymentRequired={paymentRequired}
        />
      </Box>
      <Box px={2} py={3} mb={0.5} style={{ backgroundColor: 'white' }}>
        <PaymentInformation
          groupEvent={groupEvent}
          paymentRequired={paymentRequired}
          setPaymentRequired={setPaymentRequired}
        />
      </Box>
      <Box p={2} style={{ backgroundColor: 'white' }}>
        <RegisterButton
          groupEvent={groupEvent}
          paymentRequired={paymentRequired}
          type="submit"
        />
      </Box>
    </>
  )
}

export default MobileLayout
